import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Paper, useTheme } from '@mui/material';
import { NAV_LAYOUT_MARGIN_START } from '../../consts/nav-layout-margin';
import { composeTreeViewFromStructure } from '../../utils/nav-tree-structure';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { useLingui } from '@lingui/react';

export default function NaviTreeView({ data, handleSetFormNumber, defaults }) {
  const theme = useTheme();
  const formDrawerWidth = theme.mixins.formDrawerWidth;
  const [items, setItems] = useState([]);
  const [expandedItems, setExpandedItems] = useState([]);
  const location = useLocation();
  const { init } = location.state;
  const { _ } = useLingui();

  const unitsOptions = useMemo(() => {
    return init.configuration.units?.elements.
    find((el) => el.label === 'Type')?.options ||
    ['Unknown'];
  }, [init.configuration.units?.elements]);

  const composeTreeView = useCallback((structure) => {
    return composeTreeViewFromStructure(structure, defaults, _, unitsOptions);
  }, [unitsOptions, _, defaults]);

  const transform = useCallback((treeElements) => {
    let result = [];

    function traverse(node) {
      result = [...result, node?.id];
      if (node?.children && node?.children?.length > 0) {
        node?.children.forEach((child) => traverse(child));
      }
    }

    treeElements.forEach((item) => traverse(item));
    return result;
  }, []);

  useEffect(() => {
    const treeItems = composeTreeView(data);
    setItems(treeItems);
    const expanded = transform(treeItems);
    setExpandedItems(expanded);
  }, [data, composeTreeView, transform]);

  const handleItemClick = (_, id) => {
    if (id === 'people' || id === 'units') return;
    return handleSetFormNumber(id);
  };

  return (
    <Box
      zIndex={theme.zIndex.drawer}
      position='absolute'
      sx={{
        insetInlineStart: `calc(${NAV_LAYOUT_MARGIN_START} + ${formDrawerWidth}px)`,
        top: `${theme.mixins.toolbar.minHeight}px`
      }}>
      
            <Paper
        variant='outlined'
        sx={{ borderWidth: '0 1px 1px 0', borderRadius: '0 0 5px 0' }}>
                <RichTreeView
          items={items}
          expandedItems={expandedItems}
          onItemClick={handleItemClick}
          slotProps={{
            label: {
              sx: {
                color: 'red'
              }
            },
            collapseIcon: {
              style: { display: 'none' }
            }
          }}
          sx={{ pr: '12px' }} />
        
            </Paper>
        </Box>);

}
